export default __webpack_public_path__ + "static/media/loader3.e0b148e8.mp4";